import { c as _c } from "react-compiler-runtime";
import { memo } from 'react';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { HeaderLeftBorder } from './HeaderLeftBorder';
import { ResizeAffordance, ResizeAffordanceSpace } from './ResizeAffordance';
import { ContextMenuHeaderTriggerButton, useFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Shared component for column headers with and without DnD.
 * It lays out the column header to compensate the space when DnD'ing a column.
 */
function ContentComponentInner(t0) {
  const $ = _c(33);
  const {
    arrowsNode,
    children,
    columnName,
    columnNamespace,
    draggedLeft,
    draggedRight,
    isDragging,
    onClick,
    onMouseDown,
    resizable,
    reorderable,
    sortDirection
  } = t0;
  const contextMenuConfig = useFDTContextMenuConfig();
  let t1;
  if ($[0] !== columnName || $[1] !== columnNamespace || $[2] !== contextMenuConfig) {
    t1 = contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.getIsContextMenuOpen({
      row: null,
      columnName,
      columnNamespace
    });
    $[0] = columnName;
    $[1] = columnNamespace;
    $[2] = contextMenuConfig;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isContextMenuOpen = t1;
  const dragAndDropStatus = resizable ? "dnd" : "no-dnd";
  const dataTestId = `content-component-${dragAndDropStatus}-${columnName}`;
  const t2 = reorderable && !isDragging && draggedLeft;
  let t3;
  if ($[4] !== t2) {
    t3 = /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(HeaderLeftBorder, {
        $shouldHighlight: t2
      })
    });
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !sortDirection;
  let t5;
  if ($[6] !== arrowsNode || $[7] !== t4) {
    t5 = /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "100",
      paddingInline: "200",
      "data-hide-when-not-hovered": t4,
      children: arrowsNode
    });
    $[6] = arrowsNode;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t5) {
    t6 = /*#__PURE__*/_jsx(Box, {
      flexGrow: 1,
      paddingInlineStart: "300",
      overflow: "auto",
      children: /*#__PURE__*/_jsx(TruncateString, {
        useFlex: true,
        alignItems: "center",
        fixedChildren: t5,
        children: children
      })
    });
    $[9] = children;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = !isContextMenuOpen;
  let t8;
  if ($[12] !== columnName || $[13] !== columnNamespace) {
    t8 = /*#__PURE__*/_jsx(ContextMenuHeaderTriggerButton, {
      columnNamespace: columnNamespace,
      columnName: columnName
    });
    $[12] = columnName;
    $[13] = columnNamespace;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = /*#__PURE__*/_jsx(Box, {
      flexShrink: 0,
      "data-hide-when-not-hovered": t7,
      children: t8
    });
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== columnName || $[19] !== columnNamespace || $[20] !== draggedRight || $[21] !== isDragging || $[22] !== onClick || $[23] !== onMouseDown || $[24] !== reorderable || $[25] !== resizable) {
    t10 = /*#__PURE__*/_jsx(Box, {
      blockSize: "100%",
      flexShrink: 0,
      children: resizable ? /*#__PURE__*/_jsx(ResizeAffordance, {
        "data-test-id": `resize-header-${columnNamespace}-${columnName}`,
        onClick: onClick,
        onMouseDown: onMouseDown,
        $shouldHighlight: reorderable && !isDragging && draggedRight
      }) : /*#__PURE__*/_jsx(ResizeAffordanceSpace, {
        $shouldHighlight: reorderable && !isDragging && draggedRight
      })
    });
    $[18] = columnName;
    $[19] = columnNamespace;
    $[20] = draggedRight;
    $[21] = isDragging;
    $[22] = onClick;
    $[23] = onMouseDown;
    $[24] = reorderable;
    $[25] = resizable;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== dataTestId || $[28] !== t10 || $[29] !== t3 || $[30] !== t6 || $[31] !== t9) {
    t11 = /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      blockSize: "100%",
      "data-test-id": dataTestId,
      inlineSize: "100%",
      children: [t3, t6, t9, t10]
    });
    $[27] = dataTestId;
    $[28] = t10;
    $[29] = t3;
    $[30] = t6;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}
export default /*#__PURE__*/memo(ContentComponentInner);